module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notification-r"
  }, [_c('div', [_c('div', [_c('h1', {
    staticClass: "text-left"
  }, [_vm._v("Receipt Order# " + _vm._s(_vm.ordercode))]), _vm._v(" "), _c('table', [_vm._m(0), _vm._v(" "), _vm._l((_vm.orderinfo), function(order) {
    return _c('tr', [_c('td', {
      staticClass: "text-left"
    }, [_c('router-link', {
      attrs: {
        "to": '/products/product/' + order.code,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(order.product_name))])], 1), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(order.category))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(order.quantity))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v("Php " + _vm._s(_vm.formatMoney(order.price)))])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "clearboth spacera"
  }), _vm._v(" "), _c('button', {
    staticClass: "button-type-h",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": _vm.exitReceipt
    }
  }, [_vm._v("Done")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticClass: "text-left"
  }, [_vm._v("Product Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-left"
  }, [_vm._v("Category")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Quantity")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Price")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c42d20c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/OrderReceipt.vue
// module id = 155
// module chunks = 0